import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import Axios from 'axios'
import { Row, Col } from 'react-bootstrap'
import config from '../config'
import { COLORS, SIZES } from '../styles/theme'
import { ChatDb } from '../firebaseConfig'
import LoadIcon from '../components/LoadIcon'
import ChatCard from '../components/Networking/ChatCard'
import UserDirectory from '../components/Networking/UserDirectory'
import ContactCard from '../components/Networking/ContactCard'
import useChat from '../utils/chatHelper'
import back from '../images/icons/back.png'
import Amplitude from '../utils/amplitudeHelper'
import Avatar from 'react-avatar'
import { desktopAssets } from 'src/containers/PreCache'
import MiniCountdown from '../components/Networking/MiniCountdown'
import MobileLayout from 'src/mobileOnlyPages/MobileLayout'
import usePageAccess, { PageEnum } from 'src/utils/usePageAccess'

const Wrapper = styled.div`
  width: 100%;

  .wrapper {
    display: flex;
    flex-direction: column;
  }

  .countdown-container {
  }

  .chat-section {
    color: #fff;

    h6 {
      text-align: center;
      font-size: 2rem;
      font-style: normal;
      font-weight: 700;
      line-height: 2.25rem;
    }
  }

  .chat-container {
    .messages {
      max-height: 600px;
    }
  }
`

export default function NetworkingLoungePageMobile({ currentUser }) {
  usePageAccess({ currentUser, page: PageEnum.Networking, toastMsg: 'Networking Lounge is currently closed' })
  const { messages, messagesLoading, messagesError, handleSubmitMessage, submitLoading, handleFetchOlderMessages, fetchLoading, scrollTrigger } =
    useChat(ChatDb)
  const [users, setUsers] = useState([])

  useEffect(() => {
    document.title = `${config.eventName} | Networking`
  }, [])

  useEffect(() => {
    Amplitude.visit('Networking Lounge')
  }, [currentUser.id])

  useEffect(() => {
    Axios({
      url: `${config.apiUrl}/api/users`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('jwt_token')}`,
      },
    }).then((result) => {
      setUsers(result.data.users)
    })
  }, [])

  const refreshPage = () => {
    window.location.reload()
  }

  return (
    <MobileLayout title="Networking Lounge" route="/lobby">
      <Wrapper>
        <div className="wrapper">
          <div className="countdown-container">
            <MiniCountdown />
          </div>
          <div className="chat-section">
            {messagesError ? (
              <button id="refresh-btn" onClick={refreshPage}>
                Connection failed. Click here to refresh.
              </button>
            ) : (
              <div className="chat-container">
                <ChatCard
                  messages={messages}
                  messagesLoading={messagesLoading}
                  handleFetchOlderMessages={handleFetchOlderMessages}
                  fetchLoading={fetchLoading}
                  scrollTrigger={scrollTrigger}
                  handleSubmitMessage={handleSubmitMessage}
                  submitLoading={submitLoading}
                  currentUser={currentUser}
                />
              </div>
            )}
          </div>
        </div>
      </Wrapper>
    </MobileLayout>
  )
}
